"use client";
import React from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import Image from "next/image";
import register from "@/public/images/register.png";

type Props = {};

const Index: React.FC<Props> = () => {
  return (
    <>
      {/* Global styles */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @keyframes neonGlow {
            0%, 100% {
              box-shadow: 
                0 0 5px #AFFF6B,
                0 0 10px #AFFF6B,
                0 0 15px #AFFF6B,
                0 0 20px #AFFF6B,
                inset 0 0 5px #AFFF6B33;
            }
            50% {
              box-shadow: 
                0 0 2px #AFFF6B,
                0 0 5px #AFFF6B,
                0 0 8px #AFFF6B,
                0 0 12px #AFFF6B,
                inset 0 0 2px #AFFF6B33;
            }
          }

          @keyframes glitch {
            0% { transform: translate(0); }
            20% { transform: translate(-2px, 2px); }
            40% { transform: translate(-2px, -2px); }
            60% { transform: translate(2px, 2px); }
            80% { transform: translate(2px, -2px); }
            100% { transform: translate(0); }
          }

          @keyframes textGlitch {
            0% {
              text-shadow: 
                0.05em 0 0 #AFFF6B,
                -0.05em -0.025em 0 #ff00ff,
                0.025em 0.05em 0 #ffff00;
            }
            15% {
              text-shadow: 
                0.05em 0 0 #AFFF6B,
                -0.05em -0.025em 0 #ff00ff,
                0.025em 0.05em 0 #ffff00;
            }
            16% {
              text-shadow: 
                -0.05em -0.025em 0 #AFFF6B,
                0.025em 0.025em 0 #ff00ff,
                -0.05em -0.05em 0 #ffff00;
            }
            49% {
              text-shadow: 
                -0.05em -0.025em 0 #AFFF6B,
                0.025em 0.025em 0 #ff00ff,
                -0.05em -0.05em 0 #ffff00;
            }
            50% {
              text-shadow: 
                0.025em 0.05em 0 #AFFF6B,
                0.05em 0 0 #ff00ff,
                0 -0.05em 0 #ffff00;
            }
            99% {
              text-shadow: 
                0.025em 0.05em 0 #AFFF6B,
                0.05em 0 0 #ff00ff,
                0 -0.05em 0 #ffff00;
            }
            100% {
              text-shadow: 
                0.05em 0 0 #AFFF6B,
                -0.05em -0.025em 0 #ff00ff,
                0.025em 0.05em 0 #ffff00;
            }
          }

          @keyframes shine {
            0% { left: -100%; }
            100% { left: 100%; }
          }

          .neon-button {
            background: linear-gradient(45deg, #AFFF6B, #91e945) !important;
            color: #000 !important;
            border: 2px solid #AFFF6B !important;
            position: relative;
            overflow: hidden;
            animation: neonGlow 2s ease-in-out infinite alternate;
            text-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
          }

          .neon-button::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
            transition: left 0.5s;
            z-index: 1;
          }

          .neon-button:hover::before {
            animation: shine 0.5s ease-in-out;
          }

          .neon-button:hover {
            animation: neonGlow 0.1s ease-in-out infinite alternate, glitch 0.3s ease-in-out infinite;
          }

          .neon-button span {
            position: relative;
            z-index: 2;
          }

          .neon-button:hover span {
            animation: textGlitch 0.5s ease-in-out infinite;
          }

          .neon-title {
            text-shadow: 
              0 0 5px #AFFF6B,
              0 0 10px #AFFF6B,
              0 0 15px #AFFF6B,
              0 0 20px #AFFF6B,
              0 0 35px #AFFF6B !important;
          }
        `,
        }}
      />

      <motion.section
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="container mx-auto my-12 px-4"
      >
        <div className="relative bg-cover bg-center rounded-[20px] p-10 flex flex-col items-center text-center text-white shadow-lg overflow-hidden">
          <div className="absolute inset-0 bg-black bg-opacity-50 z-0 rounded-[20px]" />

          <motion.h2
            initial={{ scale: 1 }}
            animate={{ scale: [1, 1.05, 1] }}
            transition={{ repeat: Infinity, duration: 2 }}
            className="relative z-10 text-3xl md:text-5xl font-extrabold mb-4 tracking-wide neon-title"
          >
            حجز السنة الجديدة!
          </motion.h2>

          <p className="relative z-10 max-w-xl font-[700] text-2xl text-[#DC4C64] m-6">
            خاص بطلاب سنتر سمارت بجميع فروعه
          </p>

          <p className="relative z-10 max-w-xl text-sm md:text-lg mb-6">
            استعد للسنة الدراسية الجديدة وسجّل دلوقتي علشان تضمن مكانك في السنتر
            والميعاد المناسب ليك.
          </p>

          <Link
            href="/dashboard/settings"
            target="_blank"
            className="relative z-10 mb-6"
          >
            {/* <Image
              src={register}
              alt="register"
              priority
              style={{
                borderRadius: "30px",
              }}
            /> */}
          </Link>

          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.9 }}
            className="relative z-10"
          >
            <Link
              href="https://registration.eduvalu.com/app/vendors"
              target="_blank"
              className="neon-button inline-block font-bold py-3 px-8 rounded-full transition-all duration-200"
            >
              <span>أحجز دلوقتي..</span>
            </Link>
          </motion.div>
        </div>
      </motion.section>
    </>
  );
};

export default Index;
